/* @flow */
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { connect } from "react-redux";

const SidebarMenuHeader = ({ title }) => (
  <div className="menu-header">{title}</div>
);

const SidebarMenuItem = ({ title, icon, to, activeOnlyWhenExact }) => (
  <Link
    className="menu-item"
    activeClassName="active"
    to={to}
    activeOnlyWhenExact={activeOnlyWhenExact}
  >
    <i className={"fa fa-fw fa-" + icon} />
    {title}
  </Link>
);

class Sidebar extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { appPath } = this.props;

    return (
      <div className="sidebar">
        <SidebarMenuHeader title="MENU" />
        <SidebarMenuItem
          title="Dashboard"
          icon="home"
          active="active"
          to={appPath}
          activeOnlyWhenExact
        />
        <SidebarMenuItem
          title="Agencje"
          icon="plus-circle"
          to={`${appPath}/agencies`}
        />
        <SidebarMenuItem
          title="Użytkownicy"
          icon="users"
          to={`${appPath}/users`}
        />
        <SidebarMenuItem
          title="Oferty"
          icon="newspaper-o"
          to={`${appPath}/offers`}
        />
        <SidebarMenuItem
          title="Aplikacje"
          icon="file-text-o"
          to={`${appPath}/applications`}
        />
        <SidebarMenuItem
          title="Artykuły"
          icon="medium"
          to={`${appPath}/articles`}
        />
        <SidebarMenuItem
          title="Administratorzy"
          icon="users"
          to={`${appPath}/admins`}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    appPath: state.config.appPath
  }),
  {}
)(Sidebar);



// WEBPACK FOOTER //
// ./src/browser/app/Sidebar.js